module.exports = __webpack_public_path__ + "img/hongbao_2_20.3cc06d5f.png";